import { DOWNLOAD_TYPES, FlexibleDataTable } from "./FlexibleDataTable";
import React from "react";
import createReactClass from "create-react-class";
import PropTypes from "prop-types";
import ElstrLangStore from "elstr-jslib/src/scripts/stores/ElstrLangStore";
import DetailsActions from "../../actions/DetailsActions";
import DetailsStore from "../../stores/DetailsStore";
import ElstrLoadingStates from "elstr-jslib/src/scripts/constants/ElstrLoadingStates";
import DetailPisysTableMessage from "./DetailPisysTableMessage";
import ElstrCache from "elstr-jslib/src/scripts/ElstrCache";
import ElstrUrlHashStore from "elstr-jslib/src/scripts/stores/ElstrUrlHashStore";

const removeDuplicates = (obj, index, arr) => {
  // "vbelv" is the specific delivery document number
  return index === arr.findIndex(item => item.vbelv === obj.vbelv);
};

const removeDuplicatesByVbeln = (obj, index, arr) => {
  // Check if the index of the current object is the same as the first occurrence of the vbeln number
  return index === arr.findIndex(item => item.vbeln === obj.vbeln);
};

const sortByDate = (a, b) => {
  // Sort array for Req. Delivery Date
  return new Date(b.vdatu) - new Date(a.vdatu);
};

const aggregateData = (materialsData, onlyNewestDeliveryDocument) => {
  return materialsData.filter(onlyNewestDeliveryDocument ? removeDuplicatesByVbeln : removeDuplicates).sort(sortByDate);
};

const DetailPisysSalesOrder = createReactClass({
  propTypes: {
    material: PropTypes.object.isRequired,
  },

  mixins: [ElstrUrlHashStore.mixin],

  storeDidChange: function () {
    this.forceUpdate();
  },

  getInitialState() {
    const { material } = this.props;
    return { material };
  },

  statics: {
    getDerivedStateFromProps(newProps, prevState) {
      if (newProps.material.sMatHdrMatnr !== prevState.renderedMaterialNumber) {
        // Start two requests for live data (loadMore = false) and cache data (loadMore = true)
        DetailsActions.getSalesOrder({
          materialNumber: newProps.material.sMatHdrMatnr,
          othersZFERfromZVGB: true,
          loadMore: false,
        });
        DetailsActions.getSalesOrder({
          materialNumber: newProps.material.sMatHdrMatnr,
          othersZFERfromZVGB: true,
          loadMore: true,
        });

        return {
          renderedMaterialNumber: newProps.material.sMatHdrMatnr,
        };
      }
      return null;
    },
  },

  render: function () {
    const materials = DetailsStore.getSalesOrder();
    const materialsLoadMore = DetailsStore.getSalesOrderLoadMore();
    const onlyNewestDeliveryDocument = ElstrCache.get("onlyNewestDeliveryDocument");

    // show the user the loading state of the app
    const loadingState = DetailsStore.getLoadingStateFlexibleTable();
    const loadingStateLoadMore = DetailsStore.getLoadingStateFlexibleDataLoadMore();
    const isLoading = loadingState !== ElstrLoadingStates.LOADED || loadingStateLoadMore !== ElstrLoadingStates.LOADED;
    let error = DetailsStore.getError();
    let infoText = "";

    if (error == null && !isLoading && materialsLoadMore.data.length === 0) {
      infoText = ElstrLangStore.text("DETAIL_TEXT_NODATA");
    }

    const combinedMaterials = [];
    if (!isLoading && materials.data && materialsLoadMore.data) {
      combinedMaterials.push(
        ...aggregateData([...materials.data, ...materialsLoadMore.data], onlyNewestDeliveryDocument),
      );
    }

    if (isLoading) {
      return <DetailPisysTableMessage isLoading />;
    } else if (error !== null) {
      return <DetailPisysTableMessage>{error}</DetailPisysTableMessage>;
    } else if (infoText) {
      return <DetailPisysTableMessage>{infoText}</DetailPisysTableMessage>;
    } else {
      return (
        <FlexibleDataTable
          dataDefintions={materials.dataDefintions}
          data={combinedMaterials}
          downloadType={DOWNLOAD_TYPES.SALES_ORDER}
        />
      );
    }
  },
});

export default DetailPisysSalesOrder;
